module.exports = __webpack_public_path__ + "static/media/kloa_cmodel.658e068c.png";